const NWF_SEAL_SRC = (typeof document !== "undefined" && document.querySelector("img.wf-art-seal")) ? document.querySelector("img.wf-art-seal").src : "";
const NWF_API_ENDPOINT = "https://nwf-generator.vercel.app/api/make-word";
const NWF_KLAVIYO_COMPANY_ID = "VWSbnx";
const NWF_KLAVIYO_LIST_ID = "VcJnd7";
const NWF_MUG_PRODUCT_URL = "/products/personalized-mug?variant=46818514075804%26nwf=preview%26nwf_cache=202605100100";
const NWF_OLD_MUG_NAME = /personalized mug/gi;
const NWF_NEW_MUG_NAME = "Nerd Word Mug";
const NWF_OCCASION_CHOICES = [
  "Love",
  "Birthday",
  "Sympathy",
  "Thank you",
  "Get well",
  "Congratulations",
  "Wedding",
  "Anniversary",
  "Thinking of you",
  "New baby"
];
const NWF_FEELING_CHOICES = {
  Love: ["Deeply chosen", "Safe and understood", "Joyfully connected"],
  Birthday: ["Loved for who you are", "Proud and celebrated", "Playful and delighted"],
  Sympathy: ["Gentle comfort", "Love remains", "Held with care"],
  "Thank you": ["Truly appreciated", "Seen and valued", "You made a difference"],
  "Get well": ["Cared for", "Hopeful and steady", "Lifted and encouraged"],
  Congratulations: ["Proud and celebrated", "You earned this", "Excited for what is next"],
  Wedding: ["Joyfully united", "Deeply devoted", "Hopeful and timeless"],
  Anniversary: ["Cherished and grateful", "Still choosing each other", "Playful and close"],
  "Thinking of you": ["Close at heart", "Seen and remembered", "Gently supported"],
  "New baby": ["Wonder and joy", "Loved and welcomed", "A beautiful new beginning"]
};
const NWF_PERSONAL_CLUE_BY_OCCASION = {
  Love: ["little_thing", "words", "together", "moment"],
  Birthday: ["little_thing", "words", "admire", "moment"],
  Sympathy: ["words", "kindness", "together", "moment"],
  "Thank you": ["kindness", "little_thing", "admire", "moment"],
  "Get well": ["kindness", "hope", "together", "admire"],
  Congratulations: ["admire", "moment", "hope", "little_thing"],
  Wedding: ["together", "moment", "admire", "hope"],
  Anniversary: ["little_thing", "together", "moment", "admire"],
  "Thinking of you": ["words", "place", "together", "moment"],
  "New baby": ["hope", "together", "admire", "moment"]
};
const NWF_PRODUCT_OPTIONS = [
  {
    kind: "journal",
    eyebrow: "The Everyday Journal",
    title: "Word-of-the-Day Journal",
    subtitle: "Your word bound onto a hardcover, 150 lined pages, perforated for clean tear-outs, 5.75″ by 8″. Flat-rate shipping & handling: $9.",
    price: "$28.97",
    unitPrice: 28.97,
    href: "/products/word-of-the-day-journal-575-8?nwf=preview",
    variantId: 47198708957340,
    defaultQuantity: 0,
    // 2026-07-14 EVE (Gregg): lifestyle slide = Gregg's own render
    // (Desktop/"NWF Images on Site"/Blank White Notebook.png) — solid
    // white hardcover lying flat on a spiral notebook beside a ribbed
    // vase. Replaces the repainted Printful catalog photo he rejected.
    // Art overlay maps onto the rotated cover face via matrix() in
    // .wf-live-art--journal-lifestyle. Slide 0 uses Printful's untouched
    // catalog hero (data-closeup-src, nwf-journal-printful-hero.png), not
    // the former square reconstruction; missing srcs fall back to the flat cover.
    image: "",
    imageAlt: "White hardcover journal lying flat on a stack of notebooks beside a ribbed glass vase",
    closeupAlt: "Printful white matte hardcover journal photographed from above"
  },
  {
    kind: "greeting-card",
    eyebrow: "The Keepsake Card",
    title: "Word-of-the-Day Greeting Card",
    subtitle: "Your word pressed onto a left-hinged 4″ × 6″ card, heavyweight white stock, blank inside. Envelope included. $9.99 each. Flat-rate shipping & handling: $7.",
    price: "$49.95",
    unitPrice: 9.99,
    href: "/products/greeting-card?nwf=preview",
    variantId: 47231150620828,
    defaultQuantity: 5,
    image: "https://cdn.shopify.com/s/files/1/0690/5970/7036/files/6a47e6d391bd6.webp?v=1783097047",
    imageAlt: "Greeting card standing on a desk beside a mug and a vase of eucalyptus"
  },
  {
    kind: "framed-poster",
    eyebrow: "The Study Print",
    title: "Framed Print with Matte",
    subtitle: "Museum-quality matte print with a black wood frame. Shatter-resistant acrylic front — no fragile glass — and it ships boxed, ready to go, with protective padding. 18″ × 24″, ready to hang. Flat-rate shipping & handling: $17.",
    price: "$97.97",
    unitPrice: 97.97,
    href: "/products/nerdword-framed-poster-16x20?nwf=preview",
    variantId: 47231164350620,
    defaultQuantity: 0,
    image: "https://cdn.shopify.com/s/files/1/0690/5970/7036/files/6a47ea3bd8f32.webp?v=1783097919",
    imageAlt: "Black framed print with a white matte leaning on a shelf beside eucalyptus and books"
  }
];

// Default panel quantities (2026-07-19): card leads at 5,
// journal and print start at 0. Zero-quantity products are skipped at
// checkout; products without defaultQuantity fall back to 1.
function nwfDefaultQuantity(product) {
  return Number.isFinite(product.defaultQuantity) ? product.defaultQuantity : 1;
}

// Quantity-aware pricing: each keepsake uses its ordinary unit price, so the
// price shown here always equals the item total for the selected quantity.
// Quantity 0 shows the single-unit price.
function nwfUnitPriceFor(product, quantity) {
  return Number.isFinite(product.unitPrice) ? product.unitPrice : 0;
}

function nwfPriceLabel(product, quantity) {
  const qty = Math.max(1, Number.isFinite(quantity) ? quantity : 0);
  const total = nwfUnitPriceFor(product, qty) * qty;
  if (!total) return product.price || "";
  return `$${total.toFixed(2)}`;
}

/* NWF PRODUCT DESIGN LOCK START: js-art-markup
   Approved by Gregg on 2026-07-17. Do not change this block unless Gregg
   explicitly unlocks one of the three named product designs. */
// Nerd Word Foundry locked product art.
// Card = approved Keepsake composition on a 480x720 design canvas (4"x6").
// Print = that same Keepsake composition scaled into the framed print panel.
// data-word-base/max are design-px word sizes; the fit routine shrinks
// below base when a long word would overflow (base === max: never grows).
const NWF_ART_WORD_SIZES = {
  "greeting-card": { base: 76, max: 76 },
  "framed-poster": { base: 231, max: 231 },
  // Journal cover: Teeinblue artwork "Journal Cover - Centered" front panel
  // (1725x2400 @300dpi) on a 480x668 design canvas (480/1725): word 300 -> 83.
  "journal": { base: 83, max: 83 }
};

// Placement classes per product kind and slide.
// closeup = flat design on the parchment well; lifestyle = design
// composited over the (white-painted) blue-box area of the scene photo.
const NWF_ART_PLACEMENTS = {
  "greeting-card": {
    closeup: "wf-live-art--greeting-card",
    lifestyle: "wf-live-art--card-lifestyle"
  },
  "framed-poster": {
    closeup: "wf-live-art--poster-closeup",
    lifestyle: "wf-live-art--poster-lifestyle"
  },
  "journal": {
    closeup: "wf-live-art--journal",
    closeupPhoto: "wf-live-art--journal-closeup",
    lifestyle: "wf-live-art--journal-lifestyle"
  }
};

const NWF_ART_LOCKUP = `
  <div class="wf-art-foot">
    <img class="wf-art-seal" src="${NWF_SEAL_SRC}" alt="Nerd Word Foundry" width="2000" height="2000">
    <div class="wf-art-tagline">A word for every feeling</div>
  </div>`;

function nwfCardArtInner(sizes) {
  return `
      <div class="wf-art-cardframe">
        <div class="wf-art-eyebrow">Word of the Day</div>
        <div class="wf-art-pos" data-preview-pos>(verb)</div>
        <div class="wf-art-wordbox"><span class="wf-art-word" data-preview-word data-word-base="${sizes.base}" data-word-max="${sizes.max}">-</span></div>
        <div class="wf-art-fleuron" aria-hidden="true"><span></span>&#10086;<span></span></div>
        <div class="wf-art-saylabel">Say it</div>
        <div class="wf-art-saywrap"><span class="wf-art-say-pron" data-preview-pronunciation>-</span></div>
        <div class="wf-art-label">Definition</div>
        <div class="wf-art-definition" data-preview-definition>-</div>
        <div class="wf-art-label wf-art-label--sentence">In a sentence</div>
        <div class="wf-art-sentence" data-preview-sample>-</div>
        ${NWF_ART_LOCKUP}
      </div>`;
}

function nwfPosterArtInner(sizes) {
  return `
      <div class="wf-art-panel wf-art-panel--keepsake-poster">
        <div class="wf-art-eyebrow">Word of the Day</div>
        <div class="wf-art-pos" data-preview-pos>(verb)</div>
        <div class="wf-art-wordbox"><span class="wf-art-word" data-preview-word data-word-base="${sizes.base}" data-word-max="${sizes.max}">-</span></div>
        <div class="wf-art-fleuron" aria-hidden="true"><span></span>&#10086;<span></span></div>
        <div class="wf-art-saylabel">Say it</div>
        <div class="wf-art-saywrap"><span class="wf-art-say-pron" data-preview-pronunciation>-</span></div>
        <div class="wf-art-label">Definition</div>
        <div class="wf-art-definition" data-preview-definition>-</div>
        <div class="wf-art-label wf-art-label--sentence">In a sentence</div>
        <div class="wf-art-sentence" data-preview-sample>-</div>
        ${NWF_ART_LOCKUP}
      </div>`;
}

// Journal cover carries exactly three elements — the pronunciation, the
// word (dominant, no trailing period), the definition. Nothing more, nothing less.
// Mirrors Teeinblue artwork "Journal Cover - Centered" (#1237616).
function nwfJournalArtInner(sizes) {
  return `
      <div class="wf-art-jourcover"><img class="wf-art-seal wf-art-seal--journal" src="${NWF_SEAL_SRC}" alt="Nerd Word Foundry" width="2000" height="2000">
        <div class="wf-art-jour-pron" data-preview-pronunciation>-</div>
        <div class="wf-art-wordbox"><span class="wf-art-word" data-preview-word data-word-base="${sizes.base}" data-word-max="${sizes.max}">-</span></div>
        <div class="wf-art-jour-definition" data-preview-definition>-</div>
      </div>`;
}

function nwfLiveArtMarkup(kind, placement = "closeup") {
  const sizes = NWF_ART_WORD_SIZES[kind] || NWF_ART_WORD_SIZES["framed-poster"];
  const placements = NWF_ART_PLACEMENTS[kind] || NWF_ART_PLACEMENTS["framed-poster"];
  const placementClass = placements[placement] || placements.closeup;

  if (kind === "greeting-card") {
    return `
        <div class="wf-live-art ${placementClass}">${nwfCardArtInner(sizes)}
        </div>`;
  }

  if (kind === "journal") {
    return `
        <div class="wf-live-art ${placementClass}">${nwfJournalArtInner(sizes)}
        </div>`;
  }

  // Framed print: the close-up carries the physical black frame + white
  // mat around the panel; the scene slide maps the bare panel into the
  // photo's mat window.
  if (placement === "closeup") {
    return `
        <div class="wf-live-art ${placementClass}">
          <div class="wf-art-mat">${nwfPosterArtInner(sizes)}
          </div>
        </div>`;
  }

  return `
        <div class="wf-live-art ${placementClass}">${nwfPosterArtInner(sizes)}
        </div>`;
}
/* NWF PRODUCT DESIGN LOCK END: js-art-markup */

function nwfProductDetailsMarkup(product) {
  const inputId = `wf-quantity-${product.kind}`;

  return `
      <div class="wf-product-details">
        <div class="wf-product-eyebrow">${product.eyebrow}</div>
        <h4 class="wf-product-title">${product.title}</h4>
        <p class="wf-product-note">${product.subtitle}</p>
        <p class="wf-product-price">${product.price}</p>
        <label class="wf-quantity-label" for="${inputId}">Quantity</label>
        <div class="wf-quantity-control" data-quantity-control="${product.kind}">
          <button class="wf-quantity-step" type="button" data-quantity-step="-1" data-product-kind="${product.kind}" aria-label="Decrease ${product.title} quantity">&minus;</button>
          <input id="${inputId}" class="wf-quantity-input" type="number" min="0" step="1" value="${nwfDefaultQuantity(product)}" inputmode="numeric" data-product-quantity="${product.kind}">
          <button class="wf-quantity-step" type="button" data-quantity-step="1" data-product-kind="${product.kind}" aria-label="Increase ${product.title} quantity">+</button>
        </div>
      </div>`;
}

function nwfProductPreviewMarkup(product, lifestyleSrc, closeupSrc) {
  const closeupArt = nwfLiveArtMarkup(product.kind, closeupSrc ? "closeupPhoto" : "closeup");
  const closeupImg = closeupSrc
    ? `<img class="wf-product-image" src="${closeupSrc}" alt="${product.closeupAlt || product.title}" width="1600" height="1600" loading="lazy">`
    : "";
  const src = lifestyleSrc || product.image;

  // Single-slide products show the flat design only — also the safe
  // fallback when no scene src is available (no arrows or dots).
  if (product.singleSlide || !src) {
    return `
    <article class="wf-product-preview wf-product-preview--${product.kind}" data-product-preview="${product.kind}" data-variant-id="${product.variantId}" data-closeup-src="${closeupSrc || ""}">
      <div class="wf-product-media wf-slideshow" data-slideshow role="group" aria-label="${product.title} preview">
        <div class="wf-slide wf-slide--active" data-slide-index="0">
          ${closeupImg}${closeupArt}
        </div>
      </div>
      ${nwfProductDetailsMarkup(product)}
    </article>
  `;
  }

  const lifestyleArt = nwfLiveArtMarkup(product.kind, "lifestyle");

  // Slide 0 = flat close-up of the design; slide 1 = design composited
  // into the scene photo. Arrows + dots stay visible on desktop and
  // mobile; clicking/tapping the image also flips to the other slide.
  const prevIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  const nextIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  return `
    <article class="wf-product-preview wf-product-preview--${product.kind}" data-product-preview="${product.kind}" data-variant-id="${product.variantId}" data-lifestyle-src="${src}" data-closeup-src="${closeupSrc || ""}">
      <div class="wf-product-media wf-slideshow" data-slideshow role="group" aria-label="${product.title} preview, 2 images">
        <div class="wf-slide wf-slide--active" data-slide-index="0">
          ${closeupImg}${closeupArt}
        </div>
        <div class="wf-slide" data-slide-index="1">
          <img class="wf-product-image" src="${src}" alt="${product.imageAlt}" width="1600" height="1600" loading="lazy">
          ${lifestyleArt}
        </div>
        <button class="wf-slide-arrow wf-slide-arrow--prev" type="button" data-slide-nav="-1" aria-label="Previous ${product.title} image">${prevIcon}</button>
        <button class="wf-slide-arrow wf-slide-arrow--next" type="button" data-slide-nav="1" aria-label="Next ${product.title} image">${nextIcon}</button>
        <div class="wf-slide-dots">
          <button class="wf-slide-dot wf-slide-dot--active" type="button" data-slide-to="0" aria-label="${product.title} image 1 of 2"></button>
          <button class="wf-slide-dot" type="button" data-slide-to="1" aria-label="${product.title} image 2 of 2"></button>
        </div>
      </div>
      ${nwfProductDetailsMarkup(product)}
    </article>
  `;
}

function nwfEmailCaptureMarkup(sectionId = "word-factory") {
  const safeSectionId = String(sectionId || "word-factory").replace(/[^a-zA-Z0-9_-]/g, "-");
  const inputId = `wf-email-${safeSectionId}`;
  const fineprintId = `wf-email-fineprint-${safeSectionId}`;
  const statusId = `wf-email-status-${safeSectionId}`;

  return `
    <form class="wf-email-capture" data-email-capture hidden novalidate>
      <h3 class="wf-email-heading">Keep <span data-email-word>your word</span>.</h3>
      <p class="wf-email-promise">We’ll send a keepsake copy of your word and its meaning to your inbox.</p>
      <div class="wf-email-fields">
        <label class="wf-email-label" for="${inputId}">Email address</label>
        <div class="wf-email-row">
          <input id="${inputId}" class="wf-input wf-email-input" type="email" placeholder="you@example.com" autocomplete="email" inputmode="email" required aria-invalid="false" aria-describedby="${fineprintId} ${statusId}" data-email-input>
          <button class="wf-btn wf-email-button" type="submit" data-action="email-word">Send me “<span data-email-word>your word</span>”</button>
        </div>
      </div>
      <p id="${fineprintId}" class="wf-email-fineprint">You’ll also receive occasional notes and gift ideas from the Foundry. Unsubscribe anytime.</p>
      <p id="${statusId}" class="wf-email-status" data-email-status role="status" aria-live="polite" aria-atomic="true"></p>
    </form>
  `;
}

function nwfProductShowcaseMarkup(liveImageSrcs = {}, closeupImageSrcs = {}) {
  return `
    <div class="wf-shop-heading">
      <h3 class="wf-shop-title">Every word, three keepsakes</h3>
      <div class="wf-fleuron wf-fleuron--narrow" aria-hidden="true"><span></span>&#10086;<span></span></div>
    </div>
    <div class="wf-product-showcase" data-product-showcase>
      <div class="wf-preview-list">
        ${NWF_PRODUCT_OPTIONS.map(product => nwfProductPreviewMarkup(product, liveImageSrcs[product.kind], closeupImageSrcs[product.kind])).join("")}
      </div>
      <div class="wf-checkout-panel">
        <button class="wf-btn wf-btn-primary wf-checkout-button" type="button" data-action="checkout">
          Go to Shopping Cart
        </button>
        <p class="wf-checkout-status" data-checkout-status aria-live="polite"></p>
      </div>
    </div>
  `;
}

const NWF_REVEAL_MARKUP = `
  <div class="wf-reveal">
    <div class="wf-reveal-script">word of the day</div>
    <div class="wf-reveal-word" data-preview-word>-</div>
    <div class="wf-reveal-pos"><span data-preview-pos-plain>verb</span>&nbsp;&nbsp;&middot;&nbsp;&nbsp;<span data-preview-pronunciation>-</span></div>
    <div class="wf-fleuron" aria-hidden="true"><span></span>&#10086;<span></span></div>
    <div class="wf-reveal-definition" data-preview-definition>-</div>
    <div class="wf-reveal-sentence" data-preview-sample>-</div>
  </div>
`;

/* Header brand: the round wreath logo now renders natively from theme
   settings (settings.logo -> nwf-seal-round-2026.png); the old 3e lockup
   JS override was removed 2026-07-13. */

function normalizeNwfProductName(root = document.body) {
  if (!root) return;

  const replaceMugName = value => String(value || "").replace(NWF_OLD_MUG_NAME, NWF_NEW_MUG_NAME);
  const hasOldMugName = value => /personalized mug/i.test(String(value || ""));

  if (document.title && hasOldMugName(document.title)) {
    document.title = replaceMugName(document.title);
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent) return NodeFilter.FILTER_REJECT;
      if (["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
      return hasOldMugName(node.nodeValue)
        ? NodeFilter.FILTER_ACCEPT
        : NodeFilter.FILTER_REJECT;
    }
  });

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    node.nodeValue = replaceMugName(node.nodeValue);
  });

  ["aria-label", "title", "alt"].forEach(attribute => {
    root.querySelectorAll?.(`[${attribute}*="Personalized Mug" i]`).forEach(element => {
      element.setAttribute(attribute, replaceMugName(element.getAttribute(attribute)));
    });
  });
}

function observeNwfProductName() {
  normalizeNwfProductName();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (/personalized mug/i.test(node.nodeValue || "")) {
            node.nodeValue = node.nodeValue.replace(NWF_OLD_MUG_NAME, NWF_NEW_MUG_NAME);
          }
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE) normalizeNwfProductName(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

class WordFactory {
  constructor(root) {
    this.root = root;
    this.sectionId = root.id.replace("word-factory-", "");
    this.endpoint = root.dataset.apiEndpoint || NWF_API_ENDPOINT;
    this.authToken = root.dataset.apiToken || "";

    this.normalizeMarkup();

    this.elements = {
      who: this.findInput("who"),
      what: this.findInput("what", "moment"),
      vibe: this.findInput("vibe", "when"),
      personalDetailType: this.findInput("personal_detail_type"),
      personalDetail: this.findInput("personal_detail"),
      personalClueGroup: root.querySelector("[data-personal-clue-group]"),
      personalClueAnswer: root.querySelector("[data-personal-clue-answer]"),
      personalCluePrompt: root.querySelector("[data-personal-clue-prompt]"),
      generalConnectionGroup: root.querySelector("[data-general-connection-group]"),
      statusText: root.querySelector(".wf-status-text"),
      resultWrap: root.querySelector(".wf-result"),
      showcaseRegion: root.querySelector("[data-showcase-region]"),
      word: root.querySelector("[data-word]"),
      pronunciation: root.querySelector("[data-pronunciation-key]"),
      description: root.querySelector("[data-description]") || root.querySelector("[data-definition]"),
      sampleSentence: root.querySelector("[data-sample-sentence]"),
      btnGenerate: root.querySelector('[data-action="generate"]'),
      btnCheckout: root.querySelector('[data-action="checkout"]'),
      checkoutStatus: root.querySelector("[data-checkout-status]"),
      emailCapture: root.querySelector("[data-email-capture]"),
      emailInput: root.querySelector("[data-email-input]"),
      btnEmailWord: root.querySelector('[data-action="email-word"]'),
      emailStatus: root.querySelector("[data-email-status]"),
      btnPlaceWord: root.querySelector('[data-action="place-word"]'),
      btnReset: root.querySelector('[data-action="reset"]'),
      purchaseStep: root.querySelector("[data-nwf-purchase-step]"),
      mugSection: this.findMugSection()
    };

    if (!this.elements.btnGenerate) return;

    this.lastGenerated = null;
    this.forgeVariant = 0;
    this.elements.btnGenerate.addEventListener("click", () => this.generate());
    this.elements.btnCheckout?.addEventListener("click", () => this.checkout());
    this.elements.emailCapture?.addEventListener("submit", (event) => {
      event.preventDefault();
      this.emailWord();
    });
    this.elements.emailInput?.addEventListener("input", () => {
      if (this.elements.emailInput?.getAttribute("aria-invalid") === "true") {
        this.elements.emailInput.setAttribute("aria-invalid", "false");
        this.setEmailStatus("");
      }
    });
    this.elements.personalDetail?.addEventListener("input", () => {
      this.forgeVariant = 0;
      this.setStatus("", false);
    });
    this.elements.btnReset?.addEventListener("click", () => this.reset());
    this.elements.btnPlaceWord?.addEventListener("click", () => this.placeWord());
    this.bindChoiceFlow();
    this.bindQuantityControls();
    this.bindSlideshows();
    this.hideMugPurchaseStep();
    this.restoreFromLink();

    // Refit the preview art once webfonts arrive (Cormorant Garamond
    // metrics differ a lot from the fallback) and on viewport resizes.
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this.fitPreviewArt());
      document.fonts.addEventListener?.("loadingdone", () => this.fitPreviewArt());
    }
    window.addEventListener("resize", () => {
      window.clearTimeout(this._artResizeTimer);
      this._artResizeTimer = window.setTimeout(() => this.fitPreviewArt(), 150);
    });
  }

  findInput(...names) {
    for (const name of names) {
      const byName = this.root.querySelector(`input[name="${name}"], textarea[name="${name}"]`);
      if (byName) return byName;

      const byId = document.getElementById(`wf-${name}-${this.sectionId}`);
      if (byId && this.root.contains(byId)) return byId;
    }

    return null;
  }

  normalizeMarkup() {
    this.root.dataset.apiEndpoint = this.endpoint;
    this.normalizeInputCopy();

    const intro = this.root.querySelector(".wf-intro");
    if (intro) {
      intro.textContent = "Tell us who it’s for, what it’s for, and the feeling you want to share. We forge a brand-new word — with its own dictionary entry — and press it onto a card, a framed print, or a journal.";
    }

    const card = this.root.querySelector(".wf-card");
    if (!card) return;

    // Keep the scene photo URLs the section liquid rendered (theme assets)
    // so the rebuild never points at deletable Shopify Files URLs.
    const liveImageSrcs = {};
    const closeupImageSrcs = {};
    this.root.querySelectorAll("[data-product-preview]").forEach(preview => {
      const kind = preview.dataset.productPreview;
      const src = preview.dataset.lifestyleSrc ||
        preview.querySelector(".wf-product-image")?.getAttribute("src");
      if (kind && src) liveImageSrcs[kind] = src;
      const closeupSrc = preview.dataset.closeupSrc || "";
      if (kind && closeupSrc) closeupImageSrcs[kind] = closeupSrc;
    });

    // The reveal lives inside the hero well; the keepsakes + checkout
    // live in the showcase region below it.
    card.innerHTML = NWF_REVEAL_MARKUP;

    const resultWrap = this.root.querySelector(".wf-result");
    let emailCapture = this.root.querySelector("[data-email-capture]");
    if (!emailCapture && resultWrap) {
      resultWrap.insertAdjacentHTML("afterend", nwfEmailCaptureMarkup(this.sectionId));
      emailCapture = this.root.querySelector("[data-email-capture]");
    } else if (emailCapture && resultWrap && emailCapture.previousElementSibling !== resultWrap) {
      resultWrap.insertAdjacentElement("afterend", emailCapture);
    }

    let region = this.root.querySelector("[data-showcase-region]");
    if (!region) {
      region = document.createElement("div");
      region.className = "wf-showcase-region";
      region.dataset.showcaseRegion = "";
      region.hidden = true;
      this.root.appendChild(region);
    }
    region.innerHTML = nwfProductShowcaseMarkup(liveImageSrcs, closeupImageSrcs);
  }

  normalizeInputCopy() {
    const who = this.findInput("who");
    const what = this.findInput("what", "moment");
    const vibe = this.findInput("vibe", "when");

    const setLabel = (input, text) => {
      if (!input?.id) return;
      const label = this.root.querySelector(`label[for="${input.id}"]`);
      if (label) label.textContent = text;
    };

    setLabel(who, "Who is this for?");
    setLabel(what, "What is this for?");
    setLabel(vibe, "What feeling fits best?");

    if (who) who.placeholder = "Maya and Roger";
    if (what) what.name = "what";
    if (vibe) vibe.name = "vibe";
    this.ensureChoiceFlow(what, vibe);
  }

  ensureChoiceFlow(what, vibe) {
    if (!what || !vibe || this.root.querySelector("[data-occasion-picks]")) return;

    const legacyPicker = this.root.querySelector("[data-moment-picks]");
    const occasionGroup = document.createElement("fieldset");
    occasionGroup.className = "wf-choice-fieldset";
    occasionGroup.dataset.occasionGroup = "";
    occasionGroup.innerHTML = `
      <legend class="wf-label">What is this for?</legend>
      <div class="wf-moment-picks" data-occasion-picks aria-label="Choose what this is for">
        ${NWF_OCCASION_CHOICES.map(choice => `<button class="wf-moment-pick" type="button" data-occasion-choice="${choice}" aria-pressed="false">${choice}</button>`).join("")}
      </div>`;

    const feelingGroup = document.createElement("fieldset");
    feelingGroup.className = "wf-choice-fieldset wf-feeling-group";
    feelingGroup.dataset.feelingGroup = "";
    feelingGroup.hidden = true;
    feelingGroup.innerHTML = `
      <legend class="wf-label">What feeling fits best?</legend>
      <div class="wf-moment-picks" data-feeling-picks aria-label="Choose the feeling that fits best"></div>`;

    const whatLabel = what.id ? this.root.querySelector(`label[for="${what.id}"]`) : null;
    const vibeLabel = vibe.id ? this.root.querySelector(`label[for="${vibe.id}"]`) : null;
    (whatLabel || what).insertAdjacentElement("beforebegin", occasionGroup);
    vibe.insertAdjacentElement("beforebegin", feelingGroup);
    whatLabel?.remove();
    vibeLabel?.remove();
    legacyPicker?.remove();
    what.type = "hidden";
    vibe.type = "hidden";
    what.classList.remove("wf-input");
    vibe.classList.remove("wf-input");
  }

  setSelectedChoice(selector, selectedButton) {
    this.root.querySelectorAll(selector).forEach(item => {
      const selected = item === selectedButton;
      item.classList.toggle("wf-moment-pick--selected", selected);
      item.setAttribute("aria-pressed", selected ? "true" : "false");
    });
  }

  showFeelingChoices(occasion, selectedFeeling = "") {
    const group = this.root.querySelector("[data-feeling-group]");
    const picker = this.root.querySelector("[data-feeling-picks]");
    const choices = NWF_FEELING_CHOICES[occasion] || [];
    if (!group || !picker || !choices.length) return;

    picker.innerHTML = choices.map(choice => {
      const selected = choice.toLowerCase() === selectedFeeling.trim().toLowerCase();
      return `<button class="wf-moment-pick${selected ? " wf-moment-pick--selected" : ""}" type="button" data-feeling-choice="${choice}" aria-pressed="${selected ? "true" : "false"}">${choice}</button>`;
    }).join("");
    group.hidden = false;
  }

  clonePersonalClueChoice(id) {
    const template = this.root.querySelector(`template[data-personal-clue-template="${id}"]`);
    return template?.content?.firstElementChild?.cloneNode(true) || null;
  }

  resetPersonalClue(hideGroup = true) {
    if (this.elements.personalDetailType) this.elements.personalDetailType.value = "";
    if (this.elements.personalDetail) {
      this.elements.personalDetail.value = "";
      this.elements.personalDetail.placeholder = "";
    }
    if (this.elements.personalCluePrompt) this.elements.personalCluePrompt.textContent = "";
    if (this.elements.personalClueAnswer) this.elements.personalClueAnswer.hidden = true;
    if (this.elements.generalConnectionGroup) this.elements.generalConnectionGroup.hidden = true;
    this.root.querySelectorAll("[data-personal-clue-choice], [data-personal-clue-action], [data-general-connection-choice]").forEach(item => {
      item.classList.remove("wf-moment-pick--selected");
      item.setAttribute("aria-pressed", "false");
    });

    const picker = this.root.querySelector("[data-personal-clue-picks]");
    if (hideGroup) {
      if (this.elements.personalClueGroup) this.elements.personalClueGroup.hidden = true;
      if (picker) picker.innerHTML = "";
    }
  }

  showPersonalClueChoices(occasion) {
    const picker = this.root.querySelector("[data-personal-clue-picks]");
    const choices = NWF_PERSONAL_CLUE_BY_OCCASION[occasion] || [];
    if (!picker || !this.elements.personalClueGroup || !choices.length) return;

    this.resetPersonalClue(false);
    picker.innerHTML = "";
    [...choices, "general", "skip"].forEach(id => {
      const choice = this.clonePersonalClueChoice(id);
      if (choice) picker.appendChild(choice);
    });
    this.elements.personalClueGroup.hidden = false;
  }

  choosePersonalClue(button) {
    const type = (button.dataset.personalClueChoice || "").trim();
    if (!type || !this.elements.personalDetailType || !this.elements.personalDetail) return;

    this.elements.personalDetailType.value = type;
    this.elements.personalDetail.value = "";
    this.elements.personalDetail.placeholder = button.dataset.personalCluePlaceholder || "";
    if (this.elements.personalCluePrompt) {
      this.elements.personalCluePrompt.textContent = button.dataset.personalCluePrompt || "";
    }
    if (this.elements.personalClueAnswer) this.elements.personalClueAnswer.hidden = false;
    if (this.elements.generalConnectionGroup) this.elements.generalConnectionGroup.hidden = true;
    this.setSelectedChoice("[data-personal-clue-choice], [data-personal-clue-action]", button);
    this.setSelectedChoice("[data-general-connection-choice]", null);
    this.forgeVariant = 0;
    this.setStatus("", false);
    this.elements.personalDetail.focus();
  }

  choosePersonalClueAction(button) {
    const action = (button.dataset.personalClueAction || "").trim();
    if (!action || !this.elements.personalDetailType || !this.elements.personalDetail) return;

    this.elements.personalDetail.value = "";
    if (this.elements.personalClueAnswer) this.elements.personalClueAnswer.hidden = true;
    this.setSelectedChoice("[data-personal-clue-choice], [data-personal-clue-action]", button);
    this.setSelectedChoice("[data-general-connection-choice]", null);

    if (action === "general") {
      this.elements.personalDetailType.value = "general";
      if (this.elements.generalConnectionGroup) this.elements.generalConnectionGroup.hidden = false;
    } else {
      this.elements.personalDetailType.value = "skip";
      if (this.elements.generalConnectionGroup) this.elements.generalConnectionGroup.hidden = true;
    }
    this.forgeVariant = 0;
    this.setStatus("", false);
  }

  chooseGeneralConnection(button) {
    const choice = (button.dataset.generalConnectionChoice || "").trim();
    const detail = (button.dataset.generalConnectionDetail || "").trim();
    if (!choice || !detail || !this.elements.personalDetailType || !this.elements.personalDetail) return;

    this.elements.personalDetailType.value = `general_${choice}`;
    this.elements.personalDetail.value = detail;
    this.setSelectedChoice("[data-general-connection-choice]", button);
    this.forgeVariant = 0;
    this.setStatus("", false);
  }

  personalClueIsComplete(inputs) {
    const type = (inputs.personal_detail_type || "").trim();
    const detail = (inputs.personal_detail || "").trim();
    if (!type) {
      this.setStatus(this.root.dataset.personalClueStatusChoose || "Choose a personal clue or skip this step.", false);
      return false;
    }
    if (type === "skip") return true;
    if (type === "general") {
      this.setStatus(this.root.dataset.personalClueStatusGeneral || "Choose a general connection or skip this step.", false);
      return false;
    }
    if (!detail) {
      this.setStatus(this.root.dataset.personalClueStatusDetail || "Add a few words, use a general connection, or skip this step.", false);
      return false;
    }
    return true;
  }

  chooseOccasion(button) {
    const occasion = (button.dataset.occasionChoice || button.textContent || "").trim();
    if (!occasion || !this.elements.what || !this.elements.vibe) return;

    this.elements.what.value = occasion;
    this.elements.vibe.value = "";
    this.resetPersonalClue(true);
    this.forgeVariant = 0;
    this.setSelectedChoice("[data-occasion-choice]", button);
    this.showFeelingChoices(occasion);
    this.setStatus("", false);
  }

  chooseFeeling(button) {
    const feeling = (button.dataset.feelingChoice || button.textContent || "").trim();
    if (!feeling || !this.elements.vibe) return;

    this.elements.vibe.value = feeling;
    this.forgeVariant = 0;
    this.setSelectedChoice("[data-feeling-choice]", button);
    if (this.elements.personalClueGroup?.hidden) {
      this.showPersonalClueChoices((this.elements.what?.value || "").trim());
    }
    this.setStatus("", false);
  }

  bindChoiceFlow() {
    this.root.addEventListener("click", event => {
      const occasionButton = event.target.closest("[data-occasion-choice]");
      if (occasionButton && this.root.contains(occasionButton)) {
        this.chooseOccasion(occasionButton);
        return;
      }

      const feelingButton = event.target.closest("[data-feeling-choice]");
      if (feelingButton && this.root.contains(feelingButton)) {
        this.chooseFeeling(feelingButton);
        return;
      }

      const personalClueButton = event.target.closest("[data-personal-clue-choice]");
      if (personalClueButton && this.root.contains(personalClueButton)) {
        this.choosePersonalClue(personalClueButton);
        return;
      }

      const personalClueAction = event.target.closest("[data-personal-clue-action]");
      if (personalClueAction && this.root.contains(personalClueAction)) {
        this.choosePersonalClueAction(personalClueAction);
        return;
      }

      const generalConnection = event.target.closest("[data-general-connection-choice]");
      if (generalConnection && this.root.contains(generalConnection)) {
        this.chooseGeneralConnection(generalConnection);
      }
    });
  }

  bindQuantityControls() {
    this.root.querySelectorAll("[data-quantity-step]").forEach(button => {
      button.addEventListener("click", () => {
        const kind = button.dataset.productKind || "";
        const input = this.root.querySelector(`[data-product-quantity="${kind}"]`);
        if (!input) return;

        const step = Number.parseInt(button.dataset.quantityStep || "0", 10);
        const current = Number.parseInt(input.value || "0", 10);
        const next = Math.max(0, (Number.isFinite(current) ? current : 0) + step);
        input.value = String(next);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    this.root.querySelectorAll("[data-product-quantity]").forEach(input => {
      input.addEventListener("change", () => {
        const value = Number.parseInt(input.value || "0", 10);
        input.value = String(Math.max(0, Number.isFinite(value) ? value : 0));
        this.updatePriceDisplays();
      });
    });

    this.updatePriceDisplays();
  }

  // Keep each keepsake's displayed price in step with its quantity —
  // e.g. the card shows $9.99 at 1 and $49.95 at 5. Runs at bind time
  // and on every change.
  updatePriceDisplays() {
    NWF_PRODUCT_OPTIONS.forEach(product => {
      const preview = this.root.querySelector(`[data-product-preview="${product.kind}"]`);
      const priceEl = preview ? preview.querySelector(".wf-product-price") : null;
      if (!priceEl) return;

      const input = this.root.querySelector(`[data-product-quantity="${product.kind}"]`);
      const raw = Number.parseInt(input?.value || "0", 10);
      const quantity = Math.max(0, Number.isFinite(raw) ? raw : 0);
      priceEl.textContent = nwfPriceLabel(product, quantity);
    });
  }

  bindSlideshows() {
    this.root.querySelectorAll("[data-slideshow]").forEach(show => {
      const slides = Array.from(show.querySelectorAll(".wf-slide"));
      const dots = Array.from(show.querySelectorAll("[data-slide-to]"));
      if (slides.length < 2) return;

      let index = 0;
      const goTo = next => {
        index = ((next % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle("wf-slide--active", i === index));
        dots.forEach((dot, i) => dot.classList.toggle("wf-slide-dot--active", i === index));
        this.fitPreviewArt();
      };

      show.addEventListener("click", event => {
        const nav = event.target.closest("[data-slide-nav]");
        if (nav) {
          goTo(index + Number.parseInt(nav.dataset.slideNav || "1", 10));
          return;
        }

        const dot = event.target.closest("[data-slide-to]");
        if (dot) {
          goTo(Number.parseInt(dot.dataset.slideTo || "0", 10));
          return;
        }

        // Clicking/tapping the image itself flips to the other view.
        goTo(index + 1);
      });
    });
  }

  findProductListSections() {
    const sections = [];
    const wordFactorySection = this.root.closest(".shopify-section");
    if (!wordFactorySection) return sections;

    let nextSection = wordFactorySection.nextElementSibling;
    while (nextSection) {
      if (nextSection.querySelector('[data-testid="product-list"]')) sections.push(nextSection);
      nextSection = nextSection.nextElementSibling;
    }

    return sections;
  }

  findMugSection() {
    return document.querySelector("[data-nwf-mug-section]") ||
      document.querySelector("#nwf-mug-section") ||
      document.querySelector(".tib-product-form")?.closest(".shopify-section");
  }

  hideProductListSections() {
    this.findProductListSections().forEach(section => {
      section.style.display = "none";
    });
  }

  hideMugPurchaseStep() {
    this.root.classList.remove("nwf-word-placed");
    if (this.elements?.purchaseStep) this.elements.purchaseStep.hidden = true;
    if (this.elements?.mugSection) this.elements.mugSection.hidden = true;
    this.hideProductListSections();
  }

  showMugPurchaseStep() {
    this.root.classList.add("nwf-word-placed");
    document.body.classList.add("nwf-mug-flow");
    this.hideProductListSections();

    if (this.elements.purchaseStep) this.elements.purchaseStep.hidden = false;

    this.elements.mugSection = this.findMugSection();
    if (this.elements.mugSection) {
      this.elements.mugSection.hidden = false;
      this.elements.mugSection.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (this.elements.purchaseStep) {
      this.elements.purchaseStep.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  setStatus(text, loading = false) {
    if (this.elements.statusText) this.elements.statusText.textContent = text || "";
    this.root.classList.toggle("word-factory--loading", loading);
  }

  getPayload() {
    return {
      who: (this.elements.who?.value || "").trim(),
      what: (this.elements.what?.value || "").trim(),
      vibe: (this.elements.vibe?.value || "").trim(),
      personal_detail_type: (this.elements.personalDetailType?.value || "").trim(),
      personal_detail: (this.elements.personalDetail?.value || "").trim(),
      variant: this.forgeVariant
    };
  }

  parseResult(result) {
    const item = result?.output?.forged?.[0] || result?.forged?.[0] || result || {};
    const word = String(item.word || item.newWord || item.new_word || "").trim();
    const rawDefinition = String(item.description || item.definition || item.meaning || "");
    const partOfSpeech = this.formatPartOfSpeech(
      item.part_of_speech || item.partOfSpeech || item.pos,
      rawDefinition
    );
    const description = this.formatDescription(rawDefinition, partOfSpeech);
    const sampleSentence = String(
      item.sampleSentence || item.sample_sentence || item.example || item.sentence || ""
    ).trim();
    const pronunciation = String(
      item.pronunciation || item.pronunciationKey || item.pronunciation_key || item.phonetic || ""
    ).trim() || this.buildPronunciation(word);

    return { word, pronunciation, partOfSpeech, description, sampleSentence };
  }

  buildPronunciation(word) {
    const clean = String(word || "")
      .replace(/[^a-z]/gi, "")
      .toLowerCase();

    if (!clean) return "";

    const chunks = clean.match(/[^aeiouy]*[aeiouy]+[^aeiouy]*/gi) || [clean];
    return `/${chunks.join("-")}/`;
  }

  formatPartOfSpeech(value, rawDefinition) {
    const raw = String(value || "").trim().toLowerCase();
    if (raw.startsWith("adj")) return "Adjective";
    if (raw.startsWith("n")) return "Noun";
    if (raw.startsWith("v")) return "Verb";

    const definition = String(rawDefinition || "").trim();
    if (/^\*?(verb|v)\*?\.\s*/i.test(definition)) return "Verb";
    if (/^\*?(adjective|adj)\*?\.\s*/i.test(definition)) return "Adjective";
    if (/^\*?(noun|n)\*?\.\s*/i.test(definition)) return "Noun";
    if (/^to\s/i.test(definition)) return "Verb";
    if (/^(the|a|an)\s/i.test(definition)) return "Noun";
    return "Noun";
  }

  formatDescription(value, partOfSpeech) {
    const text = String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^\*?adjective\*?\.\s*/i, "")
      .replace(/^adj\.\s*/i, "")
      .replace(/^\*?verb\*?\.\s*/i, "")
      .replace(/^v\.\s*/i, "")
      .replace(/^\*?noun\*?\.\s*/i, "")
      .replace(/^n\.\s*/i, "");

    if (!text) return "";

    const label = ["Verb", "Adjective", "Noun"].includes(partOfSpeech) ? partOfSpeech : "Noun";
    return `${label}. ${text.charAt(0).toUpperCase()}${text.slice(1)}`;
  }

  storeProductChoice(kind, quantity = 1) {
    const product = NWF_PRODUCT_OPTIONS.find(option => option.kind === kind);
    const safeQuantity = Math.max(1, Number.parseInt(quantity, 10) || 1);

    try {
      localStorage.setItem("nwf_selected_product", product?.kind || kind || "");
      sessionStorage.setItem("nwf_selected_product", product?.kind || kind || "");
      localStorage.setItem("nwf_selected_quantity", String(safeQuantity));
      sessionStorage.setItem("nwf_selected_quantity", String(safeQuantity));
      localStorage.setItem("nwf_checkout_after_add", "1");
    } catch (err) {
      console.warn("Unable to save selected Nerd Word product.", err);
    }
  }

  saveGeneratedWord(inputs, generated) {
    const storedInputs = {
      who: inputs.who,
      what: inputs.what,
      vibe: inputs.vibe,
      variant: inputs.variant
    };
    const stored = {
      ...storedInputs,
      ...generated,
      newWord: generated.word,
      pronunciation: generated.pronunciation,
      partOfSpeech: generated.partOfSpeech,
      definition: generated.description,
      example: generated.sampleSentence,
      momentKind: storedInputs.vibe
    };

    this.lastGenerated = stored;

    try {
      localStorage.setItem("nwf_word", generated.word);
      localStorage.setItem("nwf_part_of_speech", generated.partOfSpeech || "");
      localStorage.setItem("nwf_description", generated.description || "");
      localStorage.setItem("nwf_definition", generated.description || "");
      localStorage.setItem("nwf_pronunciation", generated.pronunciation || "");
      localStorage.setItem("nwf_sample_sentence", generated.sampleSentence || "");
      localStorage.setItem("nwf_example", generated.sampleSentence || "");
      localStorage.setItem("nwf_meta", JSON.stringify(storedInputs));
      localStorage.setItem("nwf_generated", JSON.stringify(stored));
      localStorage.removeItem("nwf_origin");

      sessionStorage.setItem("nwf_generated", JSON.stringify(stored));
      sessionStorage.setItem("nwf_pronunciation", generated.pronunciation || "");
      sessionStorage.setItem("nwf_part_of_speech", generated.partOfSpeech || "");
      sessionStorage.removeItem("nwf_origin");
    } catch (err) {
      console.warn("Unable to save generated Nerd Word data.", err);
    }

    window.dispatchEvent(new CustomEvent("nwf:wordGenerated", { detail: stored }));
  }

  clearGeneratedWord() {
    [
      "nwf_word",
      "nwf_pronunciation",
      "nwf_part_of_speech",
      "nwf_description",
      "nwf_definition",
      "nwf_origin",
      "nwf_sample_sentence",
      "nwf_example",
      "nwf_meta",
      "nwf_generated",
      "nwf_place_word",
      "nwf_checkout_after_add",
      "nwf_selected_product",
      "nwf_selected_quantity"
    ].forEach(key => {
      try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      } catch (err) {
        console.warn("Unable to clear Nerd Word data.", err);
      }
    });
  }

  /* --- Keepsake-email link restore ---
     The Klaviyo keepsake email links back with the full entry in the
     query string (?word=...&pron=...&pos=...&def=...&sent=...&for=...
     &moment=...&kind=...). When a word param is present we rebuild the
     reveal + showcase exactly as if the word had just been forged, so
     the email's link lands on THEIR word with live buy buttons. With no
     params, fall back to this session's stored word so a reload (or a
     return from checkout) doesn't wipe the funnel. Every value renders
     through textContent (XSS-safe). */
  restoreFromLink() {
    let params = null;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (err) {
      params = null;
    }

    const clean = (key, max) =>
      (params?.get(key) || "").replace(/\s+/g, " ").trim().slice(0, max);

    const word = clean("word", 60);
    if (word) {
      const description = clean("def", 500);
      const generated = {
        word,
        pronunciation: clean("pron", 80) || this.buildPronunciation(word),
        partOfSpeech: this.formatPartOfSpeech(clean("pos", 24), description),
        description,
        sampleSentence: clean("sent", 500)
      };
      const inputs = {
        who: clean("for", 120),
        what: clean("moment", 240),
        vibe: clean("kind", 40)
      };

      this.saveGeneratedWord(inputs, generated);
      this.restoreEntry(generated, inputs);
      return;
    }

    // No link params: restore this session's word after a reload or a
    // round-trip to checkout. sessionStorage only — a fresh visit
    // always starts with a clean forge.
    let stored = null;
    try {
      stored = JSON.parse(sessionStorage.getItem("nwf_generated") || "null");
    } catch (err) {
      stored = null;
    }
    if (!stored?.word) return;

    const generated = {
      word: stored.word,
      pronunciation: stored.pronunciation || this.buildPronunciation(stored.word),
      partOfSpeech: stored.partOfSpeech || "",
      description: stored.definition || stored.description || "",
      sampleSentence: stored.example || stored.sampleSentence || ""
    };
    const inputs = {
      who: stored.who || "",
      what: stored.what || "",
      vibe: stored.vibe || stored.momentKind || ""
    };

    this.lastGenerated = stored;
    this.restoreEntry(generated, inputs);
  }

  restoreEntry(generated, inputs) {
    if (this.elements.who && inputs.who) this.elements.who.value = inputs.who;
    if (this.elements.what && inputs.what) {
      this.elements.what.value = inputs.what;
      this.root.querySelectorAll("[data-occasion-choice]").forEach(item => {
        const label = (item.dataset.occasionChoice || item.textContent || "").trim().toLowerCase();
        const selected = label === inputs.what.trim().toLowerCase();
        item.classList.toggle("wf-moment-pick--selected", selected);
        item.setAttribute("aria-pressed", selected ? "true" : "false");
      });
      this.showFeelingChoices(inputs.what, inputs.vibe || "");
    }
    if (this.elements.vibe && inputs.vibe) {
      this.elements.vibe.value = inputs.vibe;
      this.root.querySelectorAll("[data-feeling-choice]").forEach(item => {
        const label = (item.dataset.feelingChoice || item.textContent || "").trim().toLowerCase();
        const selected = label === inputs.vibe.trim().toLowerCase();
        item.classList.toggle("wf-moment-pick--selected", selected);
        item.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    }

    this.renderResult(generated);
    this.setStatus("Your word is ready.");
  }

  renderResult(generated) {
    if (this.elements.word) this.elements.word.textContent = generated.word;

    const emailWord = this.artWord(generated.word);
    this.root.querySelectorAll("[data-email-word]").forEach(element => {
      element.textContent = emailWord;
    });
    if (this.elements.emailCapture) this.elements.emailCapture.hidden = false;
    this.elements.emailInput?.setAttribute("aria-invalid", "false");

    if (this.elements.pronunciation) {
      this.elements.pronunciation.textContent = generated.pronunciation || this.buildPronunciation(generated.word);
    }

    if (this.elements.description) this.elements.description.textContent = generated.description || "";
    if (this.elements.sampleSentence) this.elements.sampleSentence.textContent = generated.sampleSentence || "";
    this.renderProductPreviews(generated);

    if (!this.elements.resultWrap) return;

    this.elements.resultWrap.hidden = false;
    this.elements.resultWrap.classList.remove("wf-result--show");
    this.elements.resultWrap.offsetWidth;
    this.elements.resultWrap.classList.add("wf-result--show");

    if (this.elements.showcaseRegion) this.elements.showcaseRegion.hidden = false;

    requestAnimationFrame(() => {
      this.fitPreviewArt();
      this.elements.resultWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }

  /* --- Art text formatting (matches the print templates) --- */

  artWord(word) {
    // The approved product designs do not show a trailing word period.
    const clean = String(word || "").trim().replace(/\.+$/, "").toLowerCase();
    return clean || "-";
  }

  artPronunciation(pronunciation) {
    return String(pronunciation || "").trim().replace(/^\/+/, "").replace(/\/+$/, "").trim() || "-";
  }

  artPartOfSpeech(partOfSpeech) {
    const raw = String(partOfSpeech || "").trim().toLowerCase();
    return raw || "verb";
  }

  artDefinition(description) {
    const text = String(description || "").trim().replace(/^(verb|adjective|noun|adverb)[.:]\s*/i, "");
    return text || "-";
  }

  artSentence(sampleSentence) {
    const text = String(sampleSentence || "").trim().replace(/^["“]+/, "").replace(/["”]+$/, "");
    return text ? `“${text}”` : "-";
  }

  renderProductPreviews(generated) {
    const word = this.artWord(generated.word);
    const pronunciation = this.artPronunciation(generated.pronunciation || this.buildPronunciation(generated.word));
    const partOfSpeech = this.artPartOfSpeech(generated.partOfSpeech);
    const definition = this.artDefinition(generated.description);
    const sampleSentence = this.artSentence(generated.sampleSentence);

    this.root.querySelectorAll("[data-preview-word]").forEach(element => {
      element.textContent = word;
    });

    this.root.querySelectorAll("[data-preview-pos]").forEach(element => {
      element.textContent = `(${partOfSpeech})`;
    });

    this.root.querySelectorAll("[data-preview-pos-plain]").forEach(element => {
      element.textContent = partOfSpeech;
    });

    this.root.querySelectorAll("[data-preview-pronunciation]").forEach(element => {
      element.textContent = pronunciation;
    });

    this.root.querySelectorAll("[data-preview-definition]").forEach(element => {
      element.textContent = definition;
    });

    this.root.querySelectorAll("[data-preview-sample]").forEach(element => {
      element.textContent = sampleSentence;
    });
  }

  /* --- Art fitting ---
     The word must never overflow the art's inner
     width. Sizes are computed in DESIGN PX (--wf-word-px) so the CSS
     cqw math keeps everything proportional at every viewport width.
     base === max, so the word only ever shrinks below the print size.
     The pronunciation line shrinks the same way. Retries handle the
     moment before layout/webfonts are ready. */

  fitPreviewArt(attempt = 0) {
    let unmeasurable = false;

    this.root.querySelectorAll(".wf-live-art").forEach(art => {
      const wordEl = art.querySelector("[data-preview-word]");
      const wordBox = art.querySelector(".wf-art-wordbox");

      if (wordEl && wordBox) {
        const base = Number.parseFloat(wordEl.dataset.wordBase || "76");
        const max = Number.parseFloat(wordEl.dataset.wordMax || String(base));
        wordEl.style.setProperty("--wf-word-px", String(base));

        const avail = wordBox.clientWidth;
        const width = wordEl.getBoundingClientRect().width;

        if (avail > 0 && width > 0) {
          const next = Math.min(max, base * (avail / width) * 0.99);
          wordEl.style.setProperty("--wf-word-px", next.toFixed(2));
        } else {
          unmeasurable = true;
        }
      }

      const pronEl = art.querySelector("[data-preview-pronunciation]");
      const wrap = pronEl?.closest(".wf-art-saywrap");

      if (pronEl && wrap) {
        pronEl.style.setProperty("--wf-pron-scale", "1");

        let otherWidth = 0;
        Array.from(wrap.childNodes).forEach(node => {
          if (node === pronEl) return;
          if (node.nodeType === Node.ELEMENT_NODE) {
            otherWidth += node.getBoundingClientRect().width;
          } else if (node.nodeType === Node.TEXT_NODE && node.textContent) {
            const range = document.createRange();
            range.selectNodeContents(node);
            otherWidth += range.getBoundingClientRect().width;
          }
        });

        const avail = wrap.clientWidth - otherWidth;
        const width = pronEl.getBoundingClientRect().width;

        if (wrap.clientWidth <= 0 || width <= 0) {
          unmeasurable = true;
        } else if (avail > 0 && width > avail) {
          pronEl.style.setProperty("--wf-pron-scale", Math.max(0.4, (avail / width) * 0.98).toFixed(3));
        }
      }
    });

    if (unmeasurable && attempt < 20) {
      window.requestAnimationFrame(() => this.fitPreviewArt(attempt + 1));
    }
  }

  getCheckoutItems() {
    const data = this.lastGenerated || {};

    return NWF_PRODUCT_OPTIONS.map(product => {
      const input = this.root.querySelector(`[data-product-quantity="${product.kind}"]`);
      const rawQuantity = Number.parseInt(input?.value || "0", 10);
      const quantity = Math.max(0, Number.isFinite(rawQuantity) ? rawQuantity : 0);
      if (input) input.value = String(quantity);

      return {
        id: product.variantId,
        quantity,
        properties: {
          "New word": data.word || "",
          Pronunciation: data.pronunciation || this.buildPronunciation(data.word),
          Definition: data.description || "",
          "In a sentence": data.sampleSentence || "",
          _nwf_product: product.kind,
          _nwf_recipient: data.who || "",
          _nwf_moment: data.what || "",
          _nwf_moment_kind: data.vibe || ""
        }
      };
    }).filter(item => item.quantity > 0);
  }

  setCheckoutStatus(text, loading = false) {
    if (this.elements.checkoutStatus) this.elements.checkoutStatus.textContent = text || "";
    if (this.elements.btnCheckout) this.elements.btnCheckout.disabled = loading;
  }

  sanitizeWordTag(word) {
    return String(word || "").toLowerCase().replace(/[^a-z0-9]+/g, "").slice(0, 40);
  }

  setEmailStatus(text, pending) {
    if (this.elements.emailStatus) this.elements.emailStatus.textContent = text || "";
    this.elements.emailStatus?.classList.toggle("wf-email-status--pending", Boolean(pending));
  }

  async emailWord() {
    const generated = this.lastGenerated;
    if (!generated?.word) {
      this.setEmailStatus("Forge your word first.");
      return;
    }

    const email = (this.elements.emailInput?.value || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      this.setEmailStatus("Please enter a valid email address.");
      this.elements.emailInput?.setAttribute("aria-invalid", "true");
      this.elements.emailInput?.focus();
      return;
    }

    this.elements.emailInput?.setAttribute("aria-invalid", "false");

    const button = this.elements.btnEmailWord;
    if (button) button.disabled = true;
    this.setEmailStatus("Sealing your word...", true);

    const inputs = this.getPayload();
    const note = [
      `Word: ${generated.word}`,
      `Pronunciation: ${generated.pronunciation || ""}`,
      `Part of speech: ${generated.partOfSpeech || ""}`,
      `Definition: ${generated.description || ""}`,
      `In a sentence: ${generated.sampleSentence || ""}`,
      `Forged for: ${inputs.who || "-"} | Moment: ${inputs.what || "-"} (${inputs.vibe || "-"})`,
      `Source: word forge email capture, ${new Date().toISOString().slice(0, 10)}`
    ].join("\n");

    // Dual-rail capture: Klaviyo client event (captcha-free, carries the
    // full entry) is the primary rail; the native Shopify customer form is
    // best-effort enrichment (Shopify spam protection can 400 it).
    const [klaviyoOk, klaviyoSubOk, shopifyOk] = await Promise.all([
      this.submitKlaviyoForgeEvent(email, generated, inputs),
      this.submitKlaviyoSubscribe(email),
      this.submitShopifyCapture(email, generated, note)
    ]);

    if (klaviyoOk || klaviyoSubOk || shopifyOk) {
      this.setEmailStatus(`Sealed. ${generated.word} is saved — your keepsake email will follow.`);
      if (this.elements.emailInput) this.elements.emailInput.value = "";
      try {
        localStorage.setItem("nwf_email_captured", email);
      } catch (storageErr) {
        /* private mode; ignore */
      }
    } else {
      this.setEmailStatus("That didn't go through. Please try again.");
    }

    if (button) button.disabled = false;
  }

  async submitKlaviyoSubscribe(email) {
    try {
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Word Forge email capture",
            profile: {
              data: {
                type: "profile",
                attributes: { email }
              }
            }
          },
          relationships: {
            list: { data: { type: "list", id: NWF_KLAVIYO_LIST_ID } }
          }
        }
      };

      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${NWF_KLAVIYO_COMPANY_ID}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2024-10-15" },
        body: JSON.stringify(payload)
      });

      if (!response.ok) console.warn(`Nerd Word Klaviyo subscribe declined (${response.status})`);
      return response.ok;
    } catch (err) {
      console.warn("Nerd Word Klaviyo subscribe failed:", err);
      return false;
    }
  }

  async submitShopifyCapture(email, generated, note) {
    const body = new URLSearchParams();
    body.set("form_type", "customer");
    body.set("utf8", "✓");
    body.set("contact[email]", email);
    body.set("contact[tags]", `word-forge-lead,forged-word-${this.sanitizeWordTag(generated.word)}`);
    body.set("contact[note]", note);

    try {
      const response = await fetch("/contact", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
        redirect: "follow",
        credentials: "same-origin"
      });

      const landedUrl = response.url || "";
      const ok = response.ok && !/challenge/i.test(landedUrl);
      if (!ok) console.warn(`Nerd Word Shopify capture declined (${response.status})`);
      return ok;
    } catch (err) {
      console.warn("Nerd Word Shopify capture failed:", err);
      return false;
    }
  }

  async submitKlaviyoForgeEvent(email, generated, inputs) {
    try {
      const payload = {
        data: {
          type: "event",
          attributes: {
            properties: {
              word: generated.word,
              pronunciation: generated.pronunciation || "",
              part_of_speech: generated.partOfSpeech || "",
              definition: generated.description || "",
              sentence: generated.sampleSentence || "",
              forged_for: inputs.who || "",
              moment: inputs.what || "",
              moment_kind: inputs.vibe || "",
              source: "word-forge-email-capture"
            },
            metric: { data: { type: "metric", attributes: { name: "Forged Word" } } },
            profile: { data: { type: "profile", attributes: { email } } }
          }
        }
      };

      const response = await fetch(`https://a.klaviyo.com/client/events/?company_id=${NWF_KLAVIYO_COMPANY_ID}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: "2024-10-15" },
        body: JSON.stringify(payload)
      });

      if (!response.ok) console.warn(`Nerd Word Klaviyo event declined (${response.status})`);
      return response.ok;
    } catch (err) {
      console.warn("Nerd Word Klaviyo event failed:", err);
      return false;
    }
  }

  async checkout() {
    if (!this.lastGenerated?.word) {
      this.setCheckoutStatus("Forge your word first.");
      return;
    }

    const items = this.getCheckoutItems();
    if (!items.length) {
      this.setCheckoutStatus("Set a quantity for at least one keepsake first.");
      return;
    }

    this.setCheckoutStatus("Opening checkout...", true);

    try {
      await fetch("/cart/clear.js", { method: "POST" });

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || "Shopify could not add the products.");
      }

      window.location.assign("/checkout");
    } catch (err) {
      console.error("Nerd Word checkout error:", err);
      this.setCheckoutStatus("Checkout did not open. Please try again.", false);
    }
  }

  async generate() {
    const inputs = this.getPayload();

    if (!inputs.who || !inputs.what || !inputs.vibe) {
      this.setStatus("Please add a name, choose what this is for, and choose a feeling.", false);
      return;
    }

    if (!this.personalClueIsComplete(inputs)) return;

    this.elements.btnGenerate.disabled = true;
    this.setStatus("Forging your word...", true);
    this.hideMugPurchaseStep();

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 60000);

    try {
      const response = await fetch(this.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inputs),
        signal: controller.signal
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => "");
        throw new Error(errorText || `Request failed: ${response.status}`);
      }

      const generated = this.parseResult(await response.json().catch(() => ({})));
      if (!generated.word) throw new Error("No word returned from API.");

      this.saveGeneratedWord(inputs, generated);
      this.renderResult(generated);
      this.forgeVariant = (this.forgeVariant + 1) % 3;
      this.setStatus("Your word is ready.", false);
    } catch (err) {
      console.error("Word Factory error:", err);
      const message = err.name === "AbortError"
        ? "The foundry took too long. Please try again."
        : "We could not forge that one. Please try again.";
      this.setStatus(message, false);
    } finally {
      window.clearTimeout(timeout);
      this.elements.btnGenerate.disabled = false;
    }
  }

  placeWord() {
    if (!this.lastGenerated) {
      this.setStatus("Forge your word first.", false);
      return;
    }

    try {
      localStorage.setItem("nwf_place_word", "1");
      sessionStorage.setItem("nwf_place_word", "1");
      localStorage.setItem("nwf_checkout_after_add", "1");
    } catch (err) {
      console.warn("Unable to mark Nerd Word as placed.", err);
    }

    window.dispatchEvent(new CustomEvent("nwf:placeWord", { detail: this.lastGenerated }));
    this.showMugPurchaseStep();
    this.setStatus("Opening your mug preview...", false);
    window.location.assign(NWF_MUG_PRODUCT_URL);
  }

  reset() {
    if (this.elements.who) this.elements.who.value = "";
    if (this.elements.what) this.elements.what.value = "";
    if (this.elements.vibe) this.elements.vibe.value = "";
    this.resetPersonalClue(true);
    this.root.querySelectorAll("[data-occasion-choice], [data-feeling-choice]").forEach(item => {
      item.classList.remove("wf-moment-pick--selected");
      item.setAttribute("aria-pressed", "false");
    });
    const feelingGroup = this.root.querySelector("[data-feeling-group]");
    const feelingPicks = this.root.querySelector("[data-feeling-picks]");
    if (feelingGroup) feelingGroup.hidden = true;
    if (feelingPicks) feelingPicks.innerHTML = "";
    this.lastGenerated = null;
    this.forgeVariant = 0;
    this.setStatus("", false);

    if (this.elements.resultWrap) {
      this.elements.resultWrap.hidden = true;
      this.elements.resultWrap.classList.remove("wf-result--show");
    }

    if (this.elements.showcaseRegion) this.elements.showcaseRegion.hidden = true;
    if (this.elements.emailCapture) this.elements.emailCapture.hidden = true;
    if (this.elements.emailInput) {
      this.elements.emailInput.value = "";
      this.elements.emailInput.setAttribute("aria-invalid", "false");
    }
    this.setEmailStatus("");

    this.clearGeneratedWord();
    this.hideMugPurchaseStep();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  observeNwfProductName();

  document.querySelectorAll('[id^="word-factory-"]').forEach(root => {
    if (root.dataset.nwfWordFactoryInitialized === "true") return;
    root.dataset.nwfWordFactoryInitialized = "true";
    new WordFactory(root);
  });
});
